import request from '@/utils/request'
import type * as projectType from '@/typings/project'
import type * as commonType from '@/typings/common'
import type { DashBoardAggregateTypeEnum } from '@/constants/project'
import type { YesOrNo } from '@/constants'
import type { CommonRes } from '@/typings/common'
import type { IFundData, IProjectPermission } from '@/typings/project'
import type { IGetProjectIrrListByPCodeFundGroupFundResponse } from '@/typings/project'
import type { IProjectInfo } from '@/typings/project'
import type * as common from '@/typings/common'
interface IAddTodoRequest {
  project_id: number[]
}
// 将项目添加到个人to-do
export async function addTodo(params: IAddTodoRequest) {
  return request('/api/v2/project/watch', {
    method: 'POST',
    data: params
  })
}

interface IRemoveTodoRequest {
  project_id: number
  reason: string
}
// 将项目移除到个人to-do
export async function removeTodo(params: IRemoveTodoRequest) {
  return request('/api/v2/project/watch_cancel', {
    method: 'POST',
    data: params
  })
}

// 取消中台指派
export async function apiProjectAssignCancel(params: any) {
  return request('/api/v2/project/assign_cancel', {
    method: 'POST',
    data: params
  })
}

interface ICreateCompetitorRequest {
  competitor: commonType.ICreateCompetitor
}
// 新增项目竞争者接口
export async function createCompetitor(params: ICreateCompetitorRequest) {
  return request('/api/v2/project/competitor/create', {
    method: 'POST',
    data: params
  })
}

// 编辑项目竞争者接口
export async function updateCompetitor(params: ICreateCompetitorRequest) {
  return request('/api/v2/project/competitor/update', {
    method: 'POST',
    data: params
  })
}

// 删除项目竞争者接口
export async function deleteCompetitor(params: commonType.IdParams) {
  return request('/api/v2/project/competitor/delete', {
    method: 'POST',
    data: params
  })
}

interface ICreateProjectRequest {
  project: projectType.ProjectParams
}
// 新建项目
export async function createProject(params: ICreateProjectRequest) {
  return request('/api/v2/project/create', {
    method: 'POST',
    data: params
  })
}

interface UpdateProjectRequest {
  project: projectType.IProjectBaseInfoRequest
}

// 编辑项目
export async function updateProject(params: UpdateProjectRequest) {
  return request('/api/v2/project/update', {
    method: 'POST',
    data: params
  })
}

interface IDeleteProjectRequest {
  id?: number
}
/** 删除项目 */
export async function deleteProject(params: IDeleteProjectRequest) {
  return request('/api/v2/project/delete', {
    method: 'POST',
    data: params
  })
}

// 待审批项目
export async function getProjectAudit(params: any) {
  return request('/api/v2/project/search_audit_list', {
    method: 'post',
    data: params
  })
}

interface IProjectPassRequest {
  project_id?: number
  process_step_level?: number
  content?: string
}
// 项目推荐Pass
export async function projectPass(params: IProjectPassRequest) {
  return request('/api/v2/project/pass', {
    method: 'POST',
    data: params
  })
}

interface IUpdateInvestorRequest {
  id: number
  investors: string
}
// UpdateProject2
export async function updateInvestor(params: IUpdateInvestorRequest) {
  return request('/api/v2/project/update_investor', {
    method: 'POST',
    data: params
  })
}

interface IMergeIntoProjectRequest {
  id: number
  merger_id: number
}
// 项目 - 合并项目
export async function mergeIntoProject(params: IMergeIntoProjectRequest) {
  return request('/api/v2/project/direct_merge', {
    method: 'post',
    data: params
  })
}

// 获取项目记录时间
export async function getProjectProcess(params: any) {
  return request('/api/v2/project/process_all', {
    method: 'get',
    data: params
  })
}

interface IGetBasicInfoRequest {
  id?: number
  is_need_assign_info?: number
  is_need_audit_info?: number
  is_need_company_member?: number
  is_need_competitor?: number
  is_need_my_watch_info?: number
  is_need_newest_log?: number
  is_need_newest_memo?: number
  is_need_operation_log?: number
  is_need_portfolio_info?: number
  is_need_newest_memo_tc?: number
}
// 获取项目基本信息
export async function getBasicInfo(params: IGetBasicInfoRequest) {
  return request<CommonRes<IProjectInfo>>('/api/v2/project/get', {
    method: 'GET',
    data: params
  })
}

interface IGetInfoFromQmyRequest {
  project_name?: string
}
// 获取项目企名片信息
export async function getInfoFromQmy(params: IGetInfoFromQmyRequest) {
  return request('/api/v2/project/qmp/get', {
    method: 'GET',
    data: params
  })
}

// 按项目名检索项目接口
export async function searchByName(params: commonType.KeywordsParams) {
  return request('/api/v2/project/qmp/search', {
    method: 'GET',
    data: params
  })
}

// 项目运营-卡片列表
export async function getProjectLeadsCard(params: any) {
  return request('/api/v2/project/search_project_operation_card', {
    method: 'post',
    data: params
  })
}

// 项目运营-列表
export async function getProjectLeadsNormal(params: any) {
  return request('/api/v2/project/search_project_operation_list', {
    method: 'post',
    data: params
  })
}

interface IAddVisitLogRequest {
  project_id: number
}
// 添加项目访问记录
export async function addVisitLog(params: IAddVisitLogRequest) {
  return request('/api/v2/project/add_visit_record', {
    method: 'post',
    data: params
  })
}

interface IGetVisitLogListRequest {
  end_time?: number
  page?: number
  project_id?: number
  size?: number
  start_time?: number
}
// 项目访问记录列表
export async function getVisitLogList(params: IGetVisitLogListRequest) {
  return request('/api/v2/project/project_visit_record_list', {
    method: 'get',
    data: params
  })
}

interface IIcConfirmRequest {
  remark?: string
  vote_id?: number
  vote_result?: number
  vote_system?: number
  on_condition_yes?: YesOrNo
  is_rmb_iii?: YesOrNo
  force?: boolean // 缺交易架构投资金额时强推确认（PDWY-4702 需求2，根级 ADR-003）
}
// PC确认（状态）
export async function icConfirm(params: IIcConfirmRequest) {
  return request('/api/v2/project/memo/vote/pc_confirm', {
    method: 'post',
    data: params
  })
}

// 卡片视图hover展示融资信息 - 获取项目标签
export async function getProjectTag(params: any) {
  return request('/api/v2/project/get_tag', {
    method: 'get',
    data: params
  })
}

interface IGetLogChannelRequest {
  project_id: number
}
// 项目 - 获取历史赛道数据
export async function getLogChannel(params: IGetLogChannelRequest) {
  return request('/api/v2/project/list_channel_record', {
    method: 'get',
    data: params
  })
}

interface IApplyGoldBulletRequest {
  vote_id: number
}
// 项目 - 申请使用金子弹
export async function applyGoldBullet(params: IApplyGoldBulletRequest) {
  return request('/api/v2/project/memo/vote/apply_gold', {
    method: 'post',
    data: params
  })
}

// 系统账号管理 - 即时更新所有账号的文件、资料库等权限设置
export async function checkAccountChange(params: any) {
  return request('/api/v2/project/reload_file_relation_data', {
    method: 'post',
    data: params
  })
}

interface IFinishFONotJoinRequest {
  memo_id: number
}
// 完成FO不参与接口
export async function finishFONotJoin(params: IFinishFONotJoinRequest) {
  return request('/api/v2/project/portfolio/enter_follow_on_no_participate', {
    method: 'POST',
    data: params
  })
}
interface IEnterExitRequest {
  memo_id: number
  process_step_level?: number
}
// 完成退出Memo接口
export async function enterExit(params: IEnterExitRequest) {
  return request('/api/v2/project/portfolio/enter_exit', {
    method: 'POST',
    data: params
  })
}

// 赛道汇总库 - 赛道汇总列表
export async function getChannelProjectList(params: any) {
  return request('/api/v2/project/channel_project_list', {
    method: 'GET',
    data: params
  })
}

// 项目文件库
export async function getProjectFileList(params: any) {
  return request('/api/v2/project/project_file_list', {
    method: 'GET',
    data: params
  })
}

interface searchMemoProjectListRequest {
  keywords?: string
  project_id?: number
}
// 搜索有memo的项目
export async function searchMemoProjectList(params: searchMemoProjectListRequest) {
  return request('/api/v2/project/search_has_memo_project_list', {
    method: 'POST',
    data: params
  })
}

interface ISearchMemoAndSubMemoProjectListRequest {
  keywords?: string
  project_id?: number
}
// 搜索有memo的项目
export async function searchMemoAndSubMemoProjectList(
  params: ISearchMemoAndSubMemoProjectListRequest
) {
  return request('/api/v2/project/search_has_memo_project_and_secondary_memo_project_list', {
    method: 'GET',
    data: params
  })
}

export interface IGetLeadsDashboardRequest {
  aggregate_types: DashBoardAggregateTypeEnum[]
  channel_ids?: number[]
  end_time?: number
  model_type?: string
  pm_ids?: number[]
  product_thesis_ids?: number[]
  start_time?: number
  team_ids?: number[]
  time_type?: number
}
// 搜索有memo的项目
export async function getLeadsDashboard(params: IGetLeadsDashboardRequest) {
  return request('/api/v2/project/leads_dashboard', {
    method: 'GET',
    data: params
  })
}
export interface IStrValueRange {
  end?: string
  start?: string
}

export interface ITimeRange {
  end?: number
  start?: number
}
export interface IGetProjectIrrListByPCodeFundGroupFundRequest {
  channel_ids?: number[]
  currency?: string
  end_time?: string
  fund_ids?: number[]
  is_bf_wht?: number
  latest_post_valuation?: IStrValueRange
  moic?: IStrValueRange
  moic_bf_wht?: IStrValueRange
  nav?: IStrValueRange
  nav_bf_wht?: IStrValueRange
  net_gain?: IStrValueRange
  net_gain_bf_wht?: IStrValueRange
  page?: number
  pm_ids?: number[]
  project_name?: string
  size?: number
  sort?: string
  start_time?: string
  total_cost?: IStrValueRange
  total_ownership?: IStrValueRange
  total_realized_value?: IStrValueRange
  wuyuan_first_captable_date?: ITimeRange
}
// 搜索有memo的项目
export async function getProjectIrrListByPCodeFundGroupFund(
  params: IGetProjectIrrListByPCodeFundGroupFundRequest
) {
  return request<CommonRes<IGetProjectIrrListByPCodeFundGroupFundResponse>>(
    '/api/v2/project/portfolio_irr_list_by_pcode_fund_group_fund',
    {
      method: 'POST',
      data: params
    }
  )
}
export interface IGetProjectIrrByProjectIrrRequest {
  currency?: string
  project_id?: number
}
// 搜索有memo的项目
export async function getProjectIrrByProjectId(params: IGetProjectIrrByProjectIrrRequest) {
  return request<CommonRes<{ irr: IFundData; max_data_snap: number }>>(
    '/api/v2/project/portfolio_irr_get_by_project_id',
    {
      method: 'GET',
      data: params
    }
  )
}
export interface IGetProjectIrrBySnapshotIdRequest {
  currency?: string
  snapshot_id?: number
  project_id?: number
}
export async function getProjectIrrBySnapshotId(params: IGetProjectIrrBySnapshotIdRequest) {
  return request<CommonRes<{ irr: IFundData; max_data_snap: number }>>(
    '/api/v2/project/portfolio_irr_get_by_snapshot_id',
    {
      method: 'GET',
      data: params
    }
  )
}
interface IVoteUpdateScheme {
  remark?: string
  vote_id?: number
  vote_scheme?: number
  vote_system?: number
  end_time?: number
}

interface IApiUpdateSchemeParams {
  vote: IVoteUpdateScheme
}
// 搜索有memo的项目
export async function apiUpdateScheme(params: IApiUpdateSchemeParams) {
  return request('/api/v2/project/vote/update_scheme', {
    method: 'POST',
    data: params
  })
}
// 转FO Memo
export async function apiConvertToFo(params: { memo_id: number }) {
  return request('/api/v2/project/memo/convert_to_fo', {
    method: 'POST',
    data: params
  })
}
//转回FO不参与
export async function apiConvertBackToNoFo(params: { memo_id: number }) {
  return request('/api/v2/project/memo/convert_back_to_no_fo', {
    method: 'POST',
    data: params
  })
}

interface IGetPipelinePermissionParams {
  project_id?: number
  related_id?: number
  type?: number
}
// 获取Pipeline权限
export async function apiGetPipelinePermission(params: IGetPipelinePermissionParams) {
  return request<CommonRes<{ permission: IProjectPermission }>>(
    '/api/v2/project/pipeline/get_permission',
    {
      method: 'get',
      data: params
    }
  )
}
// 设置Pipeline权限
export async function apiSetPipelinePermission(params: { permission: IProjectPermission }) {
  return request('/api/v2/project/pipeline/set_permission', {
    method: 'POST',
    data: params
  })
}
// 获取Pipeline权限
export async function apiGetPortfolioPermission(params: IGetPipelinePermissionParams) {
  return request<CommonRes<{ permission: IProjectPermission }>>(
    '/api/v2/project/portfolio/get_permission',
    {
      method: 'get',
      data: params
    }
  )
}
// 设置Pipeline权限
export async function apiSetPortfolioPermission(params: { permission: IProjectPermission }) {
  return request('/api/v2/project/portfolio/set_permission', {
    method: 'POST',
    data: params
  })
}
export interface IGetProjectSponsorParams {
  memo_id?: number
  project_id?: number
}
/** 获取Sponsor */
export async function apiGetProjectSponsor(params: IGetProjectSponsorParams) {
  return request<
    CommonRes<{
      memo_sponsor?: common.Iuser
      portfolio_associate_sponsor?: common.Iuser
      portfolio_sponsor?: common.Iuser
      vote_pipeline_sponsor?: common.Iuser
      vote_pipeline_associate_sponsor?: common.Iuser
    }>
  >('/api/v2/project/get_sponsor', {
    method: 'get',
    data: params
  })
}
// Memo运营
export async function getDealFlowsMemoOperation(params: projectType.MemoSearchParams) {
  return request('/api/v2/project/search/deal_flows_memo_operation', {
    method: 'POST',
    data: params
  })
}
